import { AppRouteProps } from "@bsm/component";
import InvoiceListViewerEmailContainer from "./container/InvoiceListViewerEmailContainer";
import { EmailConfigureRoutes } from "./views/configure/EmailConfigureRoutes";
import { EmailEditRoutes } from "./views/edit/EmailEditRoutes";

export const InvoiceListViewerEmailRoutes: Array<AppRouteProps> = [
    {
        path: "email",
        element: <InvoiceListViewerEmailContainer />,
        children: [
            ...EmailConfigureRoutes,
            ...EmailEditRoutes
        ]
    },
];